// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file container_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContainerCreateSchema, ContainerListSchema, ContainerSchema, ContainerStatus, ContainerStatusJson, ContainerStatusUpdateSchema, ContainerTrackingEvent, ContainerTrackingEventJson, ContainerUpdateSchema } from "./container_pb";
import { file_container } from "./container_pb";
import type { ContainerGroupCreateSchema, ContainerGroupListSchema, ContainerGroupScheduleListSchema, ContainerGroupScheduleSchema, ContainerGroupSchema, ContainerGroupUpdateSchema, ContainerTypeCreateSchema, ContainerTypeListSchema, ContainerTypeSchema, ContainerTypeUpdateSchema, ScheduleRules, ScheduleRulesJson, ScheduleWindow, ScheduleWindowJson } from "./container_group_pb";
import { file_container_group } from "./container_group_pb";
import type { ContainerTypeStatus, ContainerTypeStatusJson, JobType, JobTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListFilter, ListFilterJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file container_service.proto.
 */
export const file_container_service: GenFile = /*@__PURE__*/
  fileDesc("Chdjb250YWluZXJfc2VydmljZS5wcm90bxIJcmFjY29vbmFpIlgKFENvbnRhaW5lclR5cGVSZXF1ZXN0EgoKAmlkGAEgAigEEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgCIAIoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkIr0BChhDb250YWluZXJUeXBlTGlzdFJlcXVlc3QSNgoWb3duZXJfb3JnYW5pemF0aW9uX2lkcxgBIAMoBFIWb3duZXJfb3JnYW5pemF0aW9uX2lkcxI3CgtsaXN0X2ZpbHRlchgCIAEoCzIVLnJhY2Nvb25haS5MaXN0RmlsdGVyUgtsaXN0X2ZpbHRlchIwCghzdGF0dXNlcxgDIAMoDjIeLnJhY2Nvb25haS5Db250YWluZXJUeXBlU3RhdHVzIlkKFUNvbnRhaW5lckdyb3VwUmVxdWVzdBIKCgJpZBgBIAIoBBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZCKQAwoZQ29udGFpbmVyR3JvdXBMaXN0UmVxdWVzdBI2ChZvd25lcl9vcmdhbml6YXRpb25faWRzGAEgAygEUhZvd25lcl9vcmdhbml6YXRpb25faWRzEi4KEmNvbnRhaW5lcl90eXBlX2lkcxgCIAMoBFISY29udGFpbmVyX3R5cGVfaWRzEjAKE3BpY2t1cF9sb2NhdGlvbl9pZHMYAyADKARSE3BpY2t1cF9sb2NhdGlvbl9pZHMSNwoLbGlzdF9maWx0ZXIYBCABKAsyFS5yYWNjb29uYWkuTGlzdEZpbHRlclILbGlzdF9maWx0ZXISPAoZcGlja3VwX2xvY2F0aW9uX2dyb3VwX2lkcxgFIAMoBFIZcGlja3VwX2xvY2F0aW9uX2dyb3VwX2lkcxIuCghqb2JfdHlwZRgGIAEoDjISLnJhY2Nvb25haS5Kb2JUeXBlUghqb2JfdHlwZRIyChRzZXJ2aWNlX3Byb3ZpZGVyX2lkcxgHIAMoBFIUc2VydmljZV9wcm92aWRlcl9pZHMiqgIKHENvbnRhaW5lckdyb3VwU2NoZWR1bGVDcmVhdGUSLgoSY29udGFpbmVyX2dyb3VwX2lkGAEgAigEUhJjb250YWluZXJfZ3JvdXBfaWQSLgoIam9iX3R5cGUYAiACKA4yEi5yYWNjb29uYWkuSm9iVHlwZVIIam9iX3R5cGUSMAoTc2VydmljZV9wcm92aWRlcl9pZBgDIAEoBFITc2VydmljZV9wcm92aWRlcl9pZBIeCgp2YWxpZF9mcm9tGAQgAigJUgp2YWxpZF9mcm9tEhoKCHZhbGlkX3RvGAUgASgJUgh2YWxpZF90bxInCgVydWxlcxgHIAIoCzIYLnJhY2Nvb25haS5TY2hlZHVsZVJ1bGVzSgQIBhAHUg1zY2hlZHVsZV90eXBlIrwCChxDb250YWluZXJHcm91cFNjaGVkdWxlVXBkYXRlEgoKAmlkGAEgAigEEjAKE3NlcnZpY2VfcHJvdmlkZXJfaWQYAiABKARSE3NlcnZpY2VfcHJvdmlkZXJfaWQSHgoKdmFsaWRfZnJvbRgDIAEoCVIKdmFsaWRfZnJvbRIaCgh2YWxpZF90bxgEIAEoCVIIdmFsaWRfdG8SJwoFcnVsZXMYBiABKAsyGC5yYWNjb29uYWkuU2NoZWR1bGVSdWxlcxImCg5jbGVhcl92YWxpZF90bxgHIAEoCFIOY2xlYXJfdmFsaWRfdG8SPAoZY2xlYXJfc2VydmljZV9wcm92aWRlcl9pZBgIIAEoCFIZY2xlYXJfc2VydmljZV9wcm92aWRlcl9pZEoECAUQBlINc2NoZWR1bGVfdHlwZSIrCh1Db250YWluZXJHcm91cFNjaGVkdWxlUmVxdWVzdBIKCgJpZBgBIAIoBCLCAgohQ29udGFpbmVyR3JvdXBTY2hlZHVsZUxpc3RSZXF1ZXN0EjAKE2NvbnRhaW5lcl9ncm91cF9pZHMYASADKARSE2NvbnRhaW5lcl9ncm91cF9pZHMSMAoTcGlja3VwX2xvY2F0aW9uX2lkcxgCIAMoBFITcGlja3VwX2xvY2F0aW9uX2lkcxIuCghqb2JfdHlwZRgDIAEoDjISLnJhY2Nvb25haS5Kb2JUeXBlUghqb2JfdHlwZRIyChRzZXJ2aWNlX3Byb3ZpZGVyX2lkcxgEIAMoBFIUc2VydmljZV9wcm92aWRlcl9pZHMSHAoJYWN0aXZlX29uGAUgASgJUglhY3RpdmVfb24SNwoLbGlzdF9maWx0ZXIYCiABKAsyFS5yYWNjb29uYWkuTGlzdEZpbHRlclILbGlzdF9maWx0ZXIihgIKDVNjaGVkdWxlRHJhZnQSLgoSY29udGFpbmVyX2dyb3VwX2lkGAEgASgEUhJjb250YWluZXJfZ3JvdXBfaWQSLgoIam9iX3R5cGUYAiABKA4yEi5yYWNjb29uYWkuSm9iVHlwZVIIam9iX3R5cGUSMAoTc2VydmljZV9wcm92aWRlcl9pZBgDIAEoBFITc2VydmljZV9wcm92aWRlcl9pZBIeCgp2YWxpZF9mcm9tGAQgASgJUgp2YWxpZF9mcm9tEhoKCHZhbGlkX3RvGAUgASgJUgh2YWxpZF90bxInCgVydWxlcxgGIAEoCzIYLnJhY2Nvb25haS5TY2hlZHVsZVJ1bGVzIr0BChZQcmV2aWV3U2NoZWR1bGVSZXF1ZXN0EiIKC3NjaGVkdWxlX2lkGAEgASgESABSC3NjaGVkdWxlX2lkEikKBWRyYWZ0GAIgASgLMhgucmFjY29vbmFpLlNjaGVkdWxlRHJhZnRIABIwChNleGNsdWRlX3NjaGVkdWxlX2lkGAMgASgEUhNleGNsdWRlX3NjaGVkdWxlX2lkEgwKBGZyb20YBCABKAkSCgoCdG8YBSABKAlCCAoGc291cmNlIk4KElNjaGVkdWxlT2NjdXJyZW5jZRIMCgRkYXRlGAEgAigJEioKB3dpbmRvd3MYAiADKAsyGS5yYWNjb29uYWkuU2NoZWR1bGVXaW5kb3ciQgoQU2NoZWR1bGVDb25mbGljdBIMCgRkYXRlGAEgAigJEiAKC3NjaGVkdWxlX2lkGAIgAigEUgtzY2hlZHVsZV9pZCJ9ChdQcmV2aWV3U2NoZWR1bGVSZXNwb25zZRIyCgtvY2N1cnJlbmNlcxgBIAMoCzIdLnJhY2Nvb25haS5TY2hlZHVsZU9jY3VycmVuY2USLgoJY29uZmxpY3RzGAIgAygLMhsucmFjY29vbmFpLlNjaGVkdWxlQ29uZmxpY3QidAogQ29tcGF0aWJsZUNvbnRhaW5lckdyb3Vwc1JlcXVlc3QSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAEgAigEUhVvd25lcl9vcmdhbml6YXRpb25faWQSGgoIdHJ1Y2tfaWQYAiACKARSCHRydWNrX2lkIlQKEENvbnRhaW5lclJlcXVlc3QSCgoCaWQYASACKAQSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAIgAigEUhVvd25lcl9vcmdhbml6YXRpb25faWQivgMKFENvbnRhaW5lckxpc3RSZXF1ZXN0EjYKFm93bmVyX29yZ2FuaXphdGlvbl9pZHMYASADKARSFm93bmVyX29yZ2FuaXphdGlvbl9pZHMSLgoSY29udGFpbmVyX3R5cGVfaWRzGAIgAygEUhJjb250YWluZXJfdHlwZV9pZHMSMAoTcGlja3VwX2xvY2F0aW9uX2lkcxgDIAMoBFITcGlja3VwX2xvY2F0aW9uX2lkcxIwChNjb250YWluZXJfZ3JvdXBfaWRzGAQgAygEUhNjb250YWluZXJfZ3JvdXBfaWRzEiwKCHN0YXR1c2VzGAUgAygOMhoucmFjY29vbmFpLkNvbnRhaW5lclN0YXR1cxI3CgtsaXN0X2ZpbHRlchgGIAEoCzIVLnJhY2Nvb25haS5MaXN0RmlsdGVyUgtsaXN0X2ZpbHRlchIOCgZzZWFyY2gYByABKAkSQwoLbGFzdF9ldmVudHMYCCADKA4yIS5yYWNjb29uYWkuQ29udGFpbmVyVHJhY2tpbmdFdmVudFILbGFzdF9ldmVudHMSHgoKZHJpdmVyX2lkcxgJIAMoBFIKZHJpdmVyX2lkczL+DgoQQ29udGFpbmVyU2VydmljZRJRChNDcmVhdGVDb250YWluZXJUeXBlEh4ucmFjY29vbmFpLkNvbnRhaW5lclR5cGVDcmVhdGUaGC5yYWNjb29uYWkuQ29udGFpbmVyVHlwZSIAElMKFEdldENvbnRhaW5lclR5cGVCeUlkEh8ucmFjY29vbmFpLkNvbnRhaW5lclR5cGVSZXF1ZXN0GhgucmFjY29vbmFpLkNvbnRhaW5lclR5cGUiABJRChNVcGRhdGVDb250YWluZXJUeXBlEh4ucmFjY29vbmFpLkNvbnRhaW5lclR5cGVVcGRhdGUaGC5yYWNjb29uYWkuQ29udGFpbmVyVHlwZSIAElkKEkxpc3RDb250YWluZXJUeXBlcxIjLnJhY2Nvb25haS5Db250YWluZXJUeXBlTGlzdFJlcXVlc3QaHC5yYWNjb29uYWkuQ29udGFpbmVyVHlwZUxpc3QiABJUChRDcmVhdGVDb250YWluZXJHcm91cBIfLnJhY2Nvb25haS5Db250YWluZXJHcm91cENyZWF0ZRoZLnJhY2Nvb25haS5Db250YWluZXJHcm91cCIAElYKFUdldENvbnRhaW5lckdyb3VwQnlJZBIgLnJhY2Nvb25haS5Db250YWluZXJHcm91cFJlcXVlc3QaGS5yYWNjb29uYWkuQ29udGFpbmVyR3JvdXAiABJUChRVcGRhdGVDb250YWluZXJHcm91cBIfLnJhY2Nvb25haS5Db250YWluZXJHcm91cFVwZGF0ZRoZLnJhY2Nvb25haS5Db250YWluZXJHcm91cCIAElwKE0xpc3RDb250YWluZXJHcm91cHMSJC5yYWNjb29uYWkuQ29udGFpbmVyR3JvdXBMaXN0UmVxdWVzdBodLnJhY2Nvb25haS5Db250YWluZXJHcm91cExpc3QiABJWChREZWxldGVDb250YWluZXJHcm91cBIgLnJhY2Nvb25haS5Db250YWluZXJHcm91cFJlcXVlc3QaGi5yYWNjb29uYWkuTWVzc2FnZVJlc3BvbnNlIgASdQolTGlzdENvbXBhdGlibGVDb250YWluZXJHcm91cHNGb3JUcnVjaxIrLnJhY2Nvb25haS5Db21wYXRpYmxlQ29udGFpbmVyR3JvdXBzUmVxdWVzdBodLnJhY2Nvb25haS5Db250YWluZXJHcm91cExpc3QiABJsChxDcmVhdGVDb250YWluZXJHcm91cFNjaGVkdWxlEicucmFjY29vbmFpLkNvbnRhaW5lckdyb3VwU2NoZWR1bGVDcmVhdGUaIS5yYWNjb29uYWkuQ29udGFpbmVyR3JvdXBTY2hlZHVsZSIAEmwKHFVwZGF0ZUNvbnRhaW5lckdyb3VwU2NoZWR1bGUSJy5yYWNjb29uYWkuQ29udGFpbmVyR3JvdXBTY2hlZHVsZVVwZGF0ZRohLnJhY2Nvb25haS5Db250YWluZXJHcm91cFNjaGVkdWxlIgASZgocRGVsZXRlQ29udGFpbmVyR3JvdXBTY2hlZHVsZRIoLnJhY2Nvb25haS5Db250YWluZXJHcm91cFNjaGVkdWxlUmVxdWVzdBoaLnJhY2Nvb25haS5NZXNzYWdlUmVzcG9uc2UiABJ0ChtMaXN0Q29udGFpbmVyR3JvdXBTY2hlZHVsZXMSLC5yYWNjb29uYWkuQ29udGFpbmVyR3JvdXBTY2hlZHVsZUxpc3RSZXF1ZXN0GiUucmFjY29vbmFpLkNvbnRhaW5lckdyb3VwU2NoZWR1bGVMaXN0IgASWgoPUHJldmlld1NjaGVkdWxlEiEucmFjY29vbmFpLlByZXZpZXdTY2hlZHVsZVJlcXVlc3QaIi5yYWNjb29uYWkuUHJldmlld1NjaGVkdWxlUmVzcG9uc2UiABJFCg9DcmVhdGVDb250YWluZXISGi5yYWNjb29uYWkuQ29udGFpbmVyQ3JlYXRlGhQucmFjY29vbmFpLkNvbnRhaW5lciIAEkcKEEdldENvbnRhaW5lckJ5SWQSGy5yYWNjb29uYWkuQ29udGFpbmVyUmVxdWVzdBoULnJhY2Nvb25haS5Db250YWluZXIiABJFCg9VcGRhdGVDb250YWluZXISGi5yYWNjb29uYWkuQ29udGFpbmVyVXBkYXRlGhQucmFjY29vbmFpLkNvbnRhaW5lciIAEk0KDkxpc3RDb250YWluZXJzEh8ucmFjY29vbmFpLkNvbnRhaW5lckxpc3RSZXF1ZXN0GhgucmFjY29vbmFpLkNvbnRhaW5lckxpc3QiABJMCg9EZWxldGVDb250YWluZXISGy5yYWNjb29uYWkuQ29udGFpbmVyUmVxdWVzdBoaLnJhY2Nvb25haS5NZXNzYWdlUmVzcG9uc2UiABJZChdVcGRhdGVDb250YWluZXJMb2NhdGlvbhIgLnJhY2Nvb25haS5Db250YWluZXJTdGF0dXNVcGRhdGUaGi5yYWNjb29uYWkuTWVzc2FnZVJlc3BvbnNlIgBCBloELi9wYg", [file_container, file_container_group, file_enums, file_general]);

/**
 * @generated from message raccoonai.ContainerTypeRequest
 */
export type ContainerTypeRequest = Message<"raccoonai.ContainerTypeRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.ContainerTypeRequest
 */
export type ContainerTypeRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.ContainerTypeRequest.
 * Use `create(ContainerTypeRequestSchema)` to create a new message.
 */
export const ContainerTypeRequestSchema: GenMessage<ContainerTypeRequest, {jsonType: ContainerTypeRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 0);

/**
 * @generated from message raccoonai.ContainerTypeListRequest
 */
export type ContainerTypeListRequest = Message<"raccoonai.ContainerTypeListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 2 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * Empty matches every status.
   *
   * @generated from field: repeated raccoonai.ContainerTypeStatus statuses = 3;
   */
  statuses: ContainerTypeStatus[];
};

/**
 * @generated from message raccoonai.ContainerTypeListRequest
 */
export type ContainerTypeListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 2 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * Empty matches every status.
   *
   * @generated from field: repeated raccoonai.ContainerTypeStatus statuses = 3;
   */
  statuses?: ContainerTypeStatusJson[];
};

/**
 * Describes the message raccoonai.ContainerTypeListRequest.
 * Use `create(ContainerTypeListRequestSchema)` to create a new message.
 */
export const ContainerTypeListRequestSchema: GenMessage<ContainerTypeListRequest, {jsonType: ContainerTypeListRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 1);

/**
 * @generated from message raccoonai.ContainerGroupRequest
 */
export type ContainerGroupRequest = Message<"raccoonai.ContainerGroupRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.ContainerGroupRequest
 */
export type ContainerGroupRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.ContainerGroupRequest.
 * Use `create(ContainerGroupRequestSchema)` to create a new message.
 */
export const ContainerGroupRequestSchema: GenMessage<ContainerGroupRequest, {jsonType: ContainerGroupRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 2);

/**
 * @generated from message raccoonai.ContainerGroupListRequest
 */
export type ContainerGroupListRequest = Message<"raccoonai.ContainerGroupListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: repeated uint64 container_type_ids = 2 [json_name = "container_type_ids"];
   */
  containerTypeIds: bigint[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 3 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 4 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * Only container groups bound to these pickup location groups.
   *
   * @generated from field: repeated uint64 pickup_location_group_ids = 5 [json_name = "pickup_location_group_ids"];
   */
  pickupLocationGroupIds: bigint[];

  /**
   * Only container groups whose pickup location group binding carries this job
   * type (combined with pickup_location_group_ids: the same binding must satisfy both).
   *
   * @generated from field: optional raccoonai.JobType job_type = 6 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * Only container groups whose responsible zone holds one of these service providers.
   *
   * @generated from field: repeated uint64 service_provider_ids = 7 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];
};

/**
 * @generated from message raccoonai.ContainerGroupListRequest
 */
export type ContainerGroupListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: repeated uint64 container_type_ids = 2 [json_name = "container_type_ids"];
   */
  container_type_ids?: string[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 3 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 4 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * Only container groups bound to these pickup location groups.
   *
   * @generated from field: repeated uint64 pickup_location_group_ids = 5 [json_name = "pickup_location_group_ids"];
   */
  pickup_location_group_ids?: string[];

  /**
   * Only container groups whose pickup location group binding carries this job
   * type (combined with pickup_location_group_ids: the same binding must satisfy both).
   *
   * @generated from field: optional raccoonai.JobType job_type = 6 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * Only container groups whose responsible zone holds one of these service providers.
   *
   * @generated from field: repeated uint64 service_provider_ids = 7 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];
};

/**
 * Describes the message raccoonai.ContainerGroupListRequest.
 * Use `create(ContainerGroupListRequestSchema)` to create a new message.
 */
export const ContainerGroupListRequestSchema: GenMessage<ContainerGroupListRequest, {jsonType: ContainerGroupListRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 3);

/**
 * The schedule is authorized through its container group's contract, so requests carry no organization.
 *
 * @generated from message raccoonai.ContainerGroupScheduleCreate
 */
export type ContainerGroupScheduleCreate = Message<"raccoonai.ContainerGroupScheduleCreate"> & {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * anchors every-N-days rules
   *
   * @generated from field: required string valid_from = 4 [json_name = "valid_from"];
   */
  validFrom: string;

  /**
   * @generated from field: optional string valid_to = 5 [json_name = "valid_to"];
   */
  validTo: string;

  /**
   * @generated from field: required raccoonai.ScheduleRules rules = 7;
   */
  rules?: ScheduleRules;
};

/**
 * The schedule is authorized through its container group's contract, so requests carry no organization.
 *
 * @generated from message raccoonai.ContainerGroupScheduleCreate
 */
export type ContainerGroupScheduleCreateJson = {
  /**
   * @generated from field: required uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * anchors every-N-days rules
   *
   * @generated from field: required string valid_from = 4 [json_name = "valid_from"];
   */
  valid_from?: string;

  /**
   * @generated from field: optional string valid_to = 5 [json_name = "valid_to"];
   */
  valid_to?: string;

  /**
   * @generated from field: required raccoonai.ScheduleRules rules = 7;
   */
  rules?: ScheduleRulesJson;
};

/**
 * Describes the message raccoonai.ContainerGroupScheduleCreate.
 * Use `create(ContainerGroupScheduleCreateSchema)` to create a new message.
 */
export const ContainerGroupScheduleCreateSchema: GenMessage<ContainerGroupScheduleCreate, {jsonType: ContainerGroupScheduleCreateJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 4);

/**
 * The container group and the job type of a schedule do not change; create another schedule instead.
 * A value and its clear_* flag together are rejected; every-N-days rules need a valid_from after the update.
 *
 * @generated from message raccoonai.ContainerGroupScheduleUpdate
 */
export type ContainerGroupScheduleUpdate = Message<"raccoonai.ContainerGroupScheduleUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional string valid_from = 3 [json_name = "valid_from"];
   */
  validFrom: string;

  /**
   * @generated from field: optional string valid_to = 4 [json_name = "valid_to"];
   */
  validTo: string;

  /**
   * @generated from field: optional raccoonai.ScheduleRules rules = 6;
   */
  rules?: ScheduleRules;

  /**
   * an unset field cannot say "open-ended"
   *
   * @generated from field: optional bool clear_valid_to = 7 [json_name = "clear_valid_to"];
   */
  clearValidTo: boolean;

  /**
   * back to the zone's default
   *
   * @generated from field: optional bool clear_service_provider_id = 8 [json_name = "clear_service_provider_id"];
   */
  clearServiceProviderId: boolean;
};

/**
 * The container group and the job type of a schedule do not change; create another schedule instead.
 * A value and its clear_* flag together are rejected; every-N-days rules need a valid_from after the update.
 *
 * @generated from message raccoonai.ContainerGroupScheduleUpdate
 */
export type ContainerGroupScheduleUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional string valid_from = 3 [json_name = "valid_from"];
   */
  valid_from?: string;

  /**
   * @generated from field: optional string valid_to = 4 [json_name = "valid_to"];
   */
  valid_to?: string;

  /**
   * @generated from field: optional raccoonai.ScheduleRules rules = 6;
   */
  rules?: ScheduleRulesJson;

  /**
   * an unset field cannot say "open-ended"
   *
   * @generated from field: optional bool clear_valid_to = 7 [json_name = "clear_valid_to"];
   */
  clear_valid_to?: boolean;

  /**
   * back to the zone's default
   *
   * @generated from field: optional bool clear_service_provider_id = 8 [json_name = "clear_service_provider_id"];
   */
  clear_service_provider_id?: boolean;
};

/**
 * Describes the message raccoonai.ContainerGroupScheduleUpdate.
 * Use `create(ContainerGroupScheduleUpdateSchema)` to create a new message.
 */
export const ContainerGroupScheduleUpdateSchema: GenMessage<ContainerGroupScheduleUpdate, {jsonType: ContainerGroupScheduleUpdateJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 5);

/**
 * @generated from message raccoonai.ContainerGroupScheduleRequest
 */
export type ContainerGroupScheduleRequest = Message<"raccoonai.ContainerGroupScheduleRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;
};

/**
 * @generated from message raccoonai.ContainerGroupScheduleRequest
 */
export type ContainerGroupScheduleRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;
};

/**
 * Describes the message raccoonai.ContainerGroupScheduleRequest.
 * Use `create(ContainerGroupScheduleRequestSchema)` to create a new message.
 */
export const ContainerGroupScheduleRequestSchema: GenMessage<ContainerGroupScheduleRequest, {jsonType: ContainerGroupScheduleRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 6);

/**
 * At least one of container_group_ids or pickup_location_ids is required: they carry the authorization.
 *
 * @generated from message raccoonai.ContainerGroupScheduleListRequest
 */
export type ContainerGroupScheduleListRequest = Message<"raccoonai.ContainerGroupScheduleListRequest"> & {
  /**
   * @generated from field: repeated uint64 container_group_ids = 1 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 2 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * @generated from field: optional raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * @generated from field: repeated uint64 service_provider_ids = 4 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * YYYY-MM-DD within the validity period
   *
   * @generated from field: optional string active_on = 5 [json_name = "active_on"];
   */
  activeOn: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * At least one of container_group_ids or pickup_location_ids is required: they carry the authorization.
 *
 * @generated from message raccoonai.ContainerGroupScheduleListRequest
 */
export type ContainerGroupScheduleListRequestJson = {
  /**
   * @generated from field: repeated uint64 container_group_ids = 1 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 2 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * @generated from field: optional raccoonai.JobType job_type = 3 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * @generated from field: repeated uint64 service_provider_ids = 4 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * YYYY-MM-DD within the validity period
   *
   * @generated from field: optional string active_on = 5 [json_name = "active_on"];
   */
  active_on?: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.ContainerGroupScheduleListRequest.
 * Use `create(ContainerGroupScheduleListRequestSchema)` to create a new message.
 */
export const ContainerGroupScheduleListRequestSchema: GenMessage<ContainerGroupScheduleListRequest, {jsonType: ContainerGroupScheduleListRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 7);

/**
 * A schedule form as the user fills it: nothing is required yet.
 *
 * @generated from message raccoonai.ScheduleDraft
 */
export type ScheduleDraft = Message<"raccoonai.ScheduleDraft"> & {
  /**
   * @generated from field: optional uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * @generated from field: optional raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  jobType: JobType;

  /**
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional string valid_from = 4 [json_name = "valid_from"];
   */
  validFrom: string;

  /**
   * @generated from field: optional string valid_to = 5 [json_name = "valid_to"];
   */
  validTo: string;

  /**
   * @generated from field: optional raccoonai.ScheduleRules rules = 6;
   */
  rules?: ScheduleRules;
};

/**
 * A schedule form as the user fills it: nothing is required yet.
 *
 * @generated from message raccoonai.ScheduleDraft
 */
export type ScheduleDraftJson = {
  /**
   * @generated from field: optional uint64 container_group_id = 1 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * @generated from field: optional raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;

  /**
   * @generated from field: optional uint64 service_provider_id = 3 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional string valid_from = 4 [json_name = "valid_from"];
   */
  valid_from?: string;

  /**
   * @generated from field: optional string valid_to = 5 [json_name = "valid_to"];
   */
  valid_to?: string;

  /**
   * @generated from field: optional raccoonai.ScheduleRules rules = 6;
   */
  rules?: ScheduleRulesJson;
};

/**
 * Describes the message raccoonai.ScheduleDraft.
 * Use `create(ScheduleDraftSchema)` to create a new message.
 */
export const ScheduleDraftSchema: GenMessage<ScheduleDraft, {jsonType: ScheduleDraftJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 8);

/**
 * Days a saved schedule, or a draft, puts a pickup on; the same evaluation the generator uses.
 * Overlap is per day: a container group gets one job per job type and day, whatever the windows.
 *
 * @generated from message raccoonai.PreviewScheduleRequest
 */
export type PreviewScheduleRequest = Message<"raccoonai.PreviewScheduleRequest"> & {
  /**
   * @generated from oneof raccoonai.PreviewScheduleRequest.source
   */
  source: {
    /**
     * @generated from field: uint64 schedule_id = 1 [json_name = "schedule_id"];
     */
    value: bigint;
    case: "scheduleId";
  } | {
    /**
     * @generated from field: raccoonai.ScheduleDraft draft = 2;
     */
    value: ScheduleDraft;
    case: "draft";
  } | { case: undefined; value?: undefined };

  /**
   * the one being edited
   *
   * @generated from field: optional uint64 exclude_schedule_id = 3 [json_name = "exclude_schedule_id"];
   */
  excludeScheduleId: bigint;

  /**
   * default max(today, valid_from)
   *
   * @generated from field: optional string from = 4;
   */
  from: string;

  /**
   * default min(valid_to, from + 90 days)
   *
   * @generated from field: optional string to = 5;
   */
  to: string;
};

/**
 * Days a saved schedule, or a draft, puts a pickup on; the same evaluation the generator uses.
 * Overlap is per day: a container group gets one job per job type and day, whatever the windows.
 *
 * @generated from message raccoonai.PreviewScheduleRequest
 */
export type PreviewScheduleRequestJson = {
  /**
   * @generated from field: uint64 schedule_id = 1 [json_name = "schedule_id"];
   */
  schedule_id?: string;

  /**
   * @generated from field: raccoonai.ScheduleDraft draft = 2;
   */
  draft?: ScheduleDraftJson;

  /**
   * the one being edited
   *
   * @generated from field: optional uint64 exclude_schedule_id = 3 [json_name = "exclude_schedule_id"];
   */
  exclude_schedule_id?: string;

  /**
   * default max(today, valid_from)
   *
   * @generated from field: optional string from = 4;
   */
  from?: string;

  /**
   * default min(valid_to, from + 90 days)
   *
   * @generated from field: optional string to = 5;
   */
  to?: string;
};

/**
 * Describes the message raccoonai.PreviewScheduleRequest.
 * Use `create(PreviewScheduleRequestSchema)` to create a new message.
 */
export const PreviewScheduleRequestSchema: GenMessage<PreviewScheduleRequest, {jsonType: PreviewScheduleRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 9);

/**
 * @generated from message raccoonai.ScheduleOccurrence
 */
export type ScheduleOccurrence = Message<"raccoonai.ScheduleOccurrence"> & {
  /**
   * @generated from field: required string date = 1;
   */
  date: string;

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 2;
   */
  windows: ScheduleWindow[];
};

/**
 * @generated from message raccoonai.ScheduleOccurrence
 */
export type ScheduleOccurrenceJson = {
  /**
   * @generated from field: required string date = 1;
   */
  date?: string;

  /**
   * @generated from field: repeated raccoonai.ScheduleWindow windows = 2;
   */
  windows?: ScheduleWindowJson[];
};

/**
 * Describes the message raccoonai.ScheduleOccurrence.
 * Use `create(ScheduleOccurrenceSchema)` to create a new message.
 */
export const ScheduleOccurrenceSchema: GenMessage<ScheduleOccurrence, {jsonType: ScheduleOccurrenceJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 10);

/**
 * @generated from message raccoonai.ScheduleConflict
 */
export type ScheduleConflict = Message<"raccoonai.ScheduleConflict"> & {
  /**
   * @generated from field: required string date = 1;
   */
  date: string;

  /**
   * @generated from field: required uint64 schedule_id = 2 [json_name = "schedule_id"];
   */
  scheduleId: bigint;
};

/**
 * @generated from message raccoonai.ScheduleConflict
 */
export type ScheduleConflictJson = {
  /**
   * @generated from field: required string date = 1;
   */
  date?: string;

  /**
   * @generated from field: required uint64 schedule_id = 2 [json_name = "schedule_id"];
   */
  schedule_id?: string;
};

/**
 * Describes the message raccoonai.ScheduleConflict.
 * Use `create(ScheduleConflictSchema)` to create a new message.
 */
export const ScheduleConflictSchema: GenMessage<ScheduleConflict, {jsonType: ScheduleConflictJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 11);

/**
 * @generated from message raccoonai.PreviewScheduleResponse
 */
export type PreviewScheduleResponse = Message<"raccoonai.PreviewScheduleResponse"> & {
  /**
   * @generated from field: repeated raccoonai.ScheduleOccurrence occurrences = 1;
   */
  occurrences: ScheduleOccurrence[];

  /**
   * @generated from field: repeated raccoonai.ScheduleConflict conflicts = 2;
   */
  conflicts: ScheduleConflict[];
};

/**
 * @generated from message raccoonai.PreviewScheduleResponse
 */
export type PreviewScheduleResponseJson = {
  /**
   * @generated from field: repeated raccoonai.ScheduleOccurrence occurrences = 1;
   */
  occurrences?: ScheduleOccurrenceJson[];

  /**
   * @generated from field: repeated raccoonai.ScheduleConflict conflicts = 2;
   */
  conflicts?: ScheduleConflictJson[];
};

/**
 * Describes the message raccoonai.PreviewScheduleResponse.
 * Use `create(PreviewScheduleResponseSchema)` to create a new message.
 */
export const PreviewScheduleResponseSchema: GenMessage<PreviewScheduleResponse, {jsonType: PreviewScheduleResponseJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 12);

/**
 * @generated from message raccoonai.CompatibleContainerGroupsRequest
 */
export type CompatibleContainerGroupsRequest = Message<"raccoonai.CompatibleContainerGroupsRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truckId: bigint;
};

/**
 * @generated from message raccoonai.CompatibleContainerGroupsRequest
 */
export type CompatibleContainerGroupsRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 2 [json_name = "truck_id"];
   */
  truck_id?: string;
};

/**
 * Describes the message raccoonai.CompatibleContainerGroupsRequest.
 * Use `create(CompatibleContainerGroupsRequestSchema)` to create a new message.
 */
export const CompatibleContainerGroupsRequestSchema: GenMessage<CompatibleContainerGroupsRequest, {jsonType: CompatibleContainerGroupsRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 13);

/**
 * @generated from message raccoonai.ContainerRequest
 */
export type ContainerRequest = Message<"raccoonai.ContainerRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.ContainerRequest
 */
export type ContainerRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.ContainerRequest.
 * Use `create(ContainerRequestSchema)` to create a new message.
 */
export const ContainerRequestSchema: GenMessage<ContainerRequest, {jsonType: ContainerRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 14);

/**
 * @generated from message raccoonai.ContainerListRequest
 */
export type ContainerListRequest = Message<"raccoonai.ContainerListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: repeated uint64 container_type_ids = 2 [json_name = "container_type_ids"];
   */
  containerTypeIds: bigint[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 3 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];

  /**
   * @generated from field: repeated uint64 container_group_ids = 4 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.ContainerStatus statuses = 5;
   */
  statuses: ContainerStatus[];

  /**
   * facets: "status" (ContainerStatus), "last_event" (ContainerTrackingEvent).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 6 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * Free-text search, matched case-insensitively against the container name and
   * the name of its pickup location (its own, or the one its container group is
   * bound to). Combined with the other filters by AND.
   *
   * @generated from field: optional string search = 7;
   */
  search: string;

  /**
   * UNDEFINED also matches the containers no driver has ever reported.
   *
   * @generated from field: repeated raccoonai.ContainerTrackingEvent last_events = 8 [json_name = "last_events"];
   */
  lastEvents: ContainerTrackingEvent[];

  /**
   * Drivers who serviced the container last, resolved through its last job.
   *
   * @generated from field: repeated uint64 driver_ids = 9 [json_name = "driver_ids"];
   */
  driverIds: bigint[];
};

/**
 * @generated from message raccoonai.ContainerListRequest
 */
export type ContainerListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: repeated uint64 container_type_ids = 2 [json_name = "container_type_ids"];
   */
  container_type_ids?: string[];

  /**
   * @generated from field: repeated uint64 pickup_location_ids = 3 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];

  /**
   * @generated from field: repeated uint64 container_group_ids = 4 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.ContainerStatus statuses = 5;
   */
  statuses?: ContainerStatusJson[];

  /**
   * facets: "status" (ContainerStatus), "last_event" (ContainerTrackingEvent).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 6 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * Free-text search, matched case-insensitively against the container name and
   * the name of its pickup location (its own, or the one its container group is
   * bound to). Combined with the other filters by AND.
   *
   * @generated from field: optional string search = 7;
   */
  search?: string;

  /**
   * UNDEFINED also matches the containers no driver has ever reported.
   *
   * @generated from field: repeated raccoonai.ContainerTrackingEvent last_events = 8 [json_name = "last_events"];
   */
  last_events?: ContainerTrackingEventJson[];

  /**
   * Drivers who serviced the container last, resolved through its last job.
   *
   * @generated from field: repeated uint64 driver_ids = 9 [json_name = "driver_ids"];
   */
  driver_ids?: string[];
};

/**
 * Describes the message raccoonai.ContainerListRequest.
 * Use `create(ContainerListRequestSchema)` to create a new message.
 */
export const ContainerListRequestSchema: GenMessage<ContainerListRequest, {jsonType: ContainerListRequestJson}> = /*@__PURE__*/
  messageDesc(file_container_service, 15);

/**
 * @generated from service raccoonai.ContainerService
 */
export const ContainerService: GenService<{
  /**
   * Container Type operations
   *
   * @generated from rpc raccoonai.ContainerService.CreateContainerType
   */
  createContainerType: {
    methodKind: "unary";
    input: typeof ContainerTypeCreateSchema;
    output: typeof ContainerTypeSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.GetContainerTypeById
   */
  getContainerTypeById: {
    methodKind: "unary";
    input: typeof ContainerTypeRequestSchema;
    output: typeof ContainerTypeSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.UpdateContainerType
   */
  updateContainerType: {
    methodKind: "unary";
    input: typeof ContainerTypeUpdateSchema;
    output: typeof ContainerTypeSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.ListContainerTypes
   */
  listContainerTypes: {
    methodKind: "unary";
    input: typeof ContainerTypeListRequestSchema;
    output: typeof ContainerTypeListSchema;
  },
  /**
   * Container Group operations
   *
   * @generated from rpc raccoonai.ContainerService.CreateContainerGroup
   */
  createContainerGroup: {
    methodKind: "unary";
    input: typeof ContainerGroupCreateSchema;
    output: typeof ContainerGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.GetContainerGroupById
   */
  getContainerGroupById: {
    methodKind: "unary";
    input: typeof ContainerGroupRequestSchema;
    output: typeof ContainerGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.UpdateContainerGroup
   */
  updateContainerGroup: {
    methodKind: "unary";
    input: typeof ContainerGroupUpdateSchema;
    output: typeof ContainerGroupSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.ListContainerGroups
   */
  listContainerGroups: {
    methodKind: "unary";
    input: typeof ContainerGroupListRequestSchema;
    output: typeof ContainerGroupListSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.DeleteContainerGroup
   */
  deleteContainerGroup: {
    methodKind: "unary";
    input: typeof ContainerGroupRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.ListCompatibleContainerGroupsForTruck
   */
  listCompatibleContainerGroupsForTruck: {
    methodKind: "unary";
    input: typeof CompatibleContainerGroupsRequestSchema;
    output: typeof ContainerGroupListSchema;
  },
  /**
   * ContainerGroupSchedule
   *
   * @generated from rpc raccoonai.ContainerService.CreateContainerGroupSchedule
   */
  createContainerGroupSchedule: {
    methodKind: "unary";
    input: typeof ContainerGroupScheduleCreateSchema;
    output: typeof ContainerGroupScheduleSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.UpdateContainerGroupSchedule
   */
  updateContainerGroupSchedule: {
    methodKind: "unary";
    input: typeof ContainerGroupScheduleUpdateSchema;
    output: typeof ContainerGroupScheduleSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.DeleteContainerGroupSchedule
   */
  deleteContainerGroupSchedule: {
    methodKind: "unary";
    input: typeof ContainerGroupScheduleRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.ListContainerGroupSchedules
   */
  listContainerGroupSchedules: {
    methodKind: "unary";
    input: typeof ContainerGroupScheduleListRequestSchema;
    output: typeof ContainerGroupScheduleListSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.PreviewSchedule
   */
  previewSchedule: {
    methodKind: "unary";
    input: typeof PreviewScheduleRequestSchema;
    output: typeof PreviewScheduleResponseSchema;
  },
  /**
   * Container operations
   *
   * @generated from rpc raccoonai.ContainerService.CreateContainer
   */
  createContainer: {
    methodKind: "unary";
    input: typeof ContainerCreateSchema;
    output: typeof ContainerSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.GetContainerById
   */
  getContainerById: {
    methodKind: "unary";
    input: typeof ContainerRequestSchema;
    output: typeof ContainerSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.UpdateContainer
   */
  updateContainer: {
    methodKind: "unary";
    input: typeof ContainerUpdateSchema;
    output: typeof ContainerSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.ListContainers
   */
  listContainers: {
    methodKind: "unary";
    input: typeof ContainerListRequestSchema;
    output: typeof ContainerListSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.DeleteContainer
   */
  deleteContainer: {
    methodKind: "unary";
    input: typeof ContainerRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ContainerService.UpdateContainerLocation
   */
  updateContainerLocation: {
    methodKind: "unary";
    input: typeof ContainerStatusUpdateSchema;
    output: typeof MessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_container_service, 0);

